import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_protected/profile')({
  component: lazyRouteComponent(() => import('@/pages/profile'), 'Profile'),
})
